import React, { FC, useContext, useMemo, useState } from 'react';
import CustomDialog from '../../../../common/components/CustomDialog';
import { BusinessContext } from '../../BusinessProvider/BusinessProvider';
import ConfirmationButtons from '../../../ConfirmationButtons/ConfirmationButtons';
import { useGetApas } from '../../../../hooks/queries/useGetApas';
import { formatName } from '../../../../utils/common';
import CustomAutoComplete from '../../../../common/components/CustomAutoComplete';

interface Props {
  onClose: () => void;
}

const EditBusinessAPAModal: FC<Props> = (props) => {
  const { onClose } = props;
  const { businessState, setBusinessState } = useContext(BusinessContext);
  const { data, loading } = useGetApas();
  const [apaId, setApaId] = useState<number | null>(null);

  const apas = useMemo(
    () =>
      data?.apas?.map((apa) => ({
        value: apa?.id ?? -1,
        label: formatName({
          firstName: apa?.firstName,
          lastName: apa?.lastName,
        }),
      })) ?? [],
    [data],
  );

  const _apa =
    data?.apas?.find((apa) => apa?.id === apaId) || businessState?.apa;

  return (
    <CustomDialog
      open={true}
      title="Modification apporteur d'affaire"
      maxWidth="sm"
      onClose={onClose}
      actions={
        <ConfirmationButtons
          disableConfirm={loading || apaId === null || apaId === undefined}
          handleCancel={onClose}
          handleConfirm={() => {
            if (_apa)
              setBusinessState((prevState) => ({
                ...prevState,
                apa: {
                  id: _apa?.id,
                  lastName: _apa?.lastName,
                  firstName: _apa?.firstName,
                },
              }));
            onClose();
          }}
        />
      }>
      <CustomAutoComplete
        onAutoCompleteChange={(_) => setApaId(_?.value as number)}
        onChange={() => {}}
        options={apas}
        label="Apporteur*"
        loading={loading}
      />
    </CustomDialog>
  );
};

export default EditBusinessAPAModal;
